export const BusinessTypes = {
  GROCERY: 10,
  RESTAURANT: 1,
  BAKERY: 45,
  PHARMACY: 20
}
